import React, { PropTypes } from 'react'

import data from '../../../core/data';
import MediaLinks from '../social-media/MediaLinks';

const ContactUs = (props) => {
  const address = data.about.contact.address;
  const phone = data.about.contact.phone;
  const fax = data.about.contact.fax;
  return (
    <section id="contact">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-offset-2 col-sm-5">
            <h1 className="uppercase">Head Office</h1>
            <p>{ address }</p>
            <p>{ phone }</p>
            <p>Fax: { fax }</p>
          </div>
          <div className="col-sm-5">
            <MediaLinks />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactUs;



/** WEBPACK FOOTER **
 ** ./src/components/containers/about/ContactUs.jsx
 **/